import styled from 'styled-components'

const MyDiv = styled.div`
.edit{
    display:none;
}
`
export default MyDiv
